import React, { Component } from 'react';
import moment from 'moment';

import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel'

import { Table, Tooltip, Row, Col, Statistic } from 'antd';

class UrbioticaTechMessagesTable extends Component {

  state = {
    filteredInfo: null,
    children: []
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters
    });
  };

  render() {
    let { filteredInfo } = this.state;
    filteredInfo = filteredInfo || {};
    let poms = [];
    this.props.data.forEach(element => {
      if ((element.pom) && poms.indexOf(element.pom) === -1) {
        poms.push(element.pom);
      }
    });
    poms.sort();
    let pomFilter = [];
    poms.forEach(pom => {
      pomFilter.push({ text: pom, value: pom });
    });
    return (
      <Table
        size='small'
        rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
        loading={this.props.loading ? this.props.loading : false}
        columns={[
          {
            title: 'POM',
            dataIndex: 'pom',
            key: 'pom',
            width: 30,
            filters: pomFilter,
            filteredValue: filteredInfo.pom || null,
            onFilter: (value, record) => record.pom === value,
            ellipsis: true
          }, {
            title: 'ElementID',
            dataIndex: 'elementID',
            key: 'elementID',
            width: 30,
          }, {
            title: 'Veličina',
            dataIndex: 'phenomenonID',
            key: 'phenomenonID',
            width: 150,
            filters: [{
              text: 'temperature',
              value: 'temperature',
            }, {
              text: 'node_battery',
              value: 'node_battery',
            }],
            onFilter: (value, record) => record.phenomenonid === value,
          }, {
            title: 'Hodnota',
            dataIndex: 'measures',
            key: 'measures',
            width: 50,
            render: (text, record) => {
              if (record.unit == "C") {
                return record.measures + " °" + record.unit
              } else {
                return record.measures + " " + record.unit
              }
            }
          }, {
            title: 'Časová značka',
            dataIndex: 'stamps',
            key: 'stamps',
            width: 200,
            defaultSortOrder: 'descend',
            sorter: (a, b) => dateSorter(a.stamps, b.stamps),
            render: (text, record) => {
              return moment(text).format('L LTS');
            }
          }
        ]}
        dataSource={this.props.data}
        onChange={this.handleChange}
        pagination={{
          showSizeChanger: true,
          defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
            ? parseInt(localStorage.getItem('table_pageSize'))
            : 10,
          onShowSizeChange: (current, size) => {
            localStorage.setItem('table_pageSize', size);
          }
        }}
        style={{ border: '0px' }} />
    );
  }
}

export default UrbioticaTechMessagesTable;


// WEBPACK FOOTER //
// ./src/components/UrbioticaTechMessagesTable.js